import { render, staticRenderFns } from "./exposedLabel.vue?vue&type=template&id=c69afa32&scoped=true&"
import script from "./exposedLabel.vue?vue&type=script&lang=js&"
export * from "./exposedLabel.vue?vue&type=script&lang=js&"
import style0 from "./exposedLabel.vue?vue&type=style&index=0&id=c69afa32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c69afa32",
  null
  
)

export default component.exports